import {Fragment, useRef} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useBoolState} from "@/hooks";
import SaveDialog from "./SaveDialog";
import ResyncDialog, {ResyncDialogHandler} from "@/components/extension/ResyncDialog";
import {ProvisionedDevice} from "../../types";

type Props = {
    device: ProvisionedDevice;
    domainId: number;
    userId: number;
};

export default function PhoneButton({device, domainId, userId}: Props) {
    const [isOpen, open, close] = useBoolState();
    const resyncDialogRef = useRef<ResyncDialogHandler>(null);
    return (
        <Fragment>
            <IconButton color="primary" size="small" onClick={open}>
                <FontAwesomeIcon icon="tty" />
            </IconButton>
            <SaveDialog
                provisionedDeviceId={device.id}
                domainId={domainId}
                userId={userId}
                isOpen={isOpen}
                close={close}
                openResyncPrompt={device.macAddress?.length ? () => resyncDialogRef.current.open() : null}
            />
            <ResyncDialog devicesToResync={[device.id]} ref={resyncDialogRef} name={device.macAddress} />
        </Fragment>
    );
}
